"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _HeatmapWithControls = _interopRequireDefault(require("./HeatmapWithControls.js"));

var _GeneSpecificResults = _interopRequireDefault(require("./GeneSpecificResults.js"));

var _chartDataPropTypes = require("./chartDataPropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ChartContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(ChartContainer, _React$Component);

  var _super = _createSuper(ChartContainer);

  function ChartContainer(props) {
    var _this;

    _classCallCheck(this, ChartContainer);

    _this = _super.call(this, props);
    _this.state = {
      chartType: "heatmap"
    };
    _this.handleClick = _this._handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ChartContainer, [{
    key: "_theOtherChartType",
    value: function _theOtherChartType() {
      return this.state.chartType === "heatmap" ? "boxplot and transcripts" : "heatmap";
    }
  }, {
    key: "_handleClick",
    value: function _handleClick(e) {
      e.preventDefault();
      this.setState({
        chartType: this._theOtherChartType()
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: "100%"
        }
      }, this.props.chartData.geneSpecificResults && /*#__PURE__*/_react["default"].createElement("a", {
        href: "#",
        onClick: this.handleClick
      }, "Show ".concat(this._theOtherChartType(), " view")), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: this.state.chartType === "heatmap" ? "block" : "none",
          width: "100%"
        }
      }, /*#__PURE__*/_react["default"].createElement(_HeatmapWithControls["default"], this.props.chartData)), this.props.chartData.geneSpecificResults && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: this.state.chartType === "boxplot and transcripts" ? "block" : "none",
          width: "100%"
        }
      }, /*#__PURE__*/_react["default"].createElement(_GeneSpecificResults["default"], this.props.chartData.geneSpecificResults)));
    }
  }]);

  return ChartContainer;
}(_react["default"].Component);

ChartContainer.propTypes = {
  chartData: _chartDataPropTypes.chartDataPropTypes.isRequired
};
var _default = ChartContainer;
exports["default"] = _default;